import { MijnRoute } from '../../mijn-navigatie.model';

export const MORTGAGE_INTEREST_ADJUST: MijnRoute = {
    path: 'rente/tussentijds-aanpassen',
    navigationEvent: 'toRenteTussentijdsAanpassen',
    regex: /^\/hypotheek\/rente\/tussentijds-aanpassen$/,
    webcomponent: 'mijn-hypotheken-renteverlenging-webcomponent',
    internalPath: 'tussentijds-aanpassen/aanvragen'
};
